import React, { useEffect, useState } from 'react'
import { useAuth } from '../../providers/auth_provider';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import UserStatusDropdown from './modals/user_active_inactive_modal';
import { formatDate } from '../../utils/format_date';

export default function Users() {
    const { token } = useAuth();
    const [users, setUsers] = useState([])
    const [pagination, setPagination] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(10);
    const [searchName, setSearchName] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [searchPhone, setSearchPhone] = useState('');
    const [searchStatus, setSearchStatus] = useState('');
    const navigate = useNavigate();
    const handleNavigate = (user_id) => {
        navigate('/users/view', { state: { user_id } });
    };
    useEffect(() => {
        fetchUsers(currentPage)
    }, [currentPage, limit, searchName, searchEmail, searchPhone, searchStatus]);

    useEffect(() => {
        fetchUsers(currentPage)
        setCurrentPage(1);
    }, [limit, searchName, searchEmail, searchPhone, searchStatus]);

    const fetchUsers = async (page) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/get/users?page=${page}&limit=${limit}&name=${searchName}&email=${searchEmail}&phone_no=${searchPhone}&status=${searchStatus}`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            });
            setUsers(response.data.users)
            setPagination(response.data.pagination)
        } catch (error) {
            console.error('Error fetching users:', error)
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }
    return (
        <>
            <Helmet>
                <title>Manage Users - Enervybe</title>
            </Helmet>
            {/* Users List Table */}
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">

                        <h5 className="card-title">Users List</h5>

                    </div>
                </div>
                <div className="card-datatable text-nowrap">
                    <div
                        id="DataTables_Table_0_wrapper"
                        className="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div className="dataTables_length" id="DataTables_Table_0_length">
                                    <label>
                                        Show{" "}
                                        <select
                                            name="DataTables_Table_0_length"
                                            aria-controls="DataTables_Table_0"
                                            className="form-select form-select-sm"
                                            value={limit}
                                            onChange={(e) => setLimit(e.target.value)}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>{" "}
                                        entries
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="datatables-ajax table table-bordered dataTable no-footer"
                                id="DataTables_Table_0"
                                aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Full name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Status</th>
                                        <th>Joined On</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="odd">
                                        <td></td>
                                        <td>
                                            <input
                                                type="search"
                                                className="form-control form-control-sm"
                                                placeholder="Search Name"
                                                aria-controls="DataTables_Table_0"
                                                value={searchName}
                                                onChange={(e) => setSearchName(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="search"
                                                className="form-control form-control-sm"
                                                placeholder="Search Email"
                                                aria-controls="DataTables_Table_0"
                                                value={searchEmail}
                                                onChange={(e) => setSearchEmail(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="search"
                                                className="form-control form-control-sm"
                                                placeholder="Search Phone"
                                                aria-controls="DataTables_Table_0"
                                                value={searchPhone}
                                                onChange={(e) => setSearchPhone(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <div>
                                                <label>
                                                    <select
                                                        name="DataTables_Table_0_length"
                                                        aria-controls="DataTables_Table_0"
                                                        className="form-select form-select-sm"
                                                        value={searchStatus}
                                                        onChange={(e) => setSearchStatus(e.target.value)}>
                                                        <option value={""}>All</option>
                                                        <option value={"active"}>Active</option>
                                                        <option value={"inactive"}>Inactive</option>
                                                        <option value={"suspended"}>Suspended</option>
                                                    </select>
                                                </label>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    {
                                        users?.map((user, index) => (
                                            <tr className="odd" key={user.id}>
                                                <td>{index + 1}</td>
                                                <td>{user.first_name} {user.last_name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.phone_no}</td>
                                                <td>
                                                    <UserStatusDropdown user={user} fetchUsers={fetchUsers} />
                                                </td>
                                                <td>
                                                    {formatDate(user.created_at)}
                                                </td>

                                                <td>
                                                    <button className='btn text-primary' onClick={() => handleNavigate(user.id)} >
                                                        View/Edit
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <nav aria-label="Page navigation">
                    <ul className="pagination pagination-sm pt-2">
                        <li className={`page-item prev ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage - 1)}>
                                <i className="tf-icon ri-skip-back-mini-line ri-20px" />
                            </a>
                        </li>
                        {pagination.pages && pagination.pages.map(page => (
                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(page)}>
                                    {page}
                                </a>
                            </li>
                        ))}
                        <li className={`page-item next ${currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(currentPage + 1)}>
                                <i className="tf-icon ri-skip-forward-mini-line ri-20px" />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </>

    )
}
